import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Components
import Accordion from 'components/Accordion';
// Utilities
import VideoUpload from 'components/VideoUpload';

type Props = {
  defaultExpanded?: boolean;
}

const BrandVideo:FC<Props> = ({ defaultExpanded }) => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <div className="w-full" react-scroll="brandVideo">
      <Accordion label={t('pages.quizForm.brandVideoLabel')} icon="list" defaultExpanded={defaultExpanded}>
        <div className="w-full flex flex-wrap -mx-6 -y-4 px-6 pb-3">
          <div className="w-full px-6">
            <Controller
              control={control} name="brandVideo"
              render={({ field }) => (
                <VideoUpload
                  {...field}
                  helperText="pages.quizForm.brandVideoHint1"
                />
              )}
            />
            <span className="block text-gray-400 text-sm font-light leading-5 mt-1">{t('pages.quizForm.brandVideoHint2')}</span>
            <span className="block text-gray-400 text-sm font-light leading-5">{t('pages.quizForm.brandVideoHint3')}</span>
          </div>
        </div>
      </Accordion>
    </div>
  )
}

export default BrandVideo;
